import React, { useState } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import aboutbnr from "../../images/aboutbnr.jpg";
import instance from "../../../WebApi/WebApi";
import { toast } from "react-toastify";

const Contactus = () => {
  const [contactUsData, setContactUsData] = useState({
    queryType: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const _ON_SUBMIT = async (e) => {
    e.preventDefault();
  //  console.log("contactUsData", contactUsData);
    try {
      const response = await instance.post(
        `/auth/add-contact-us`,
        contactUsData
      );
      toast.success(response?.data?.message);
    //  console.log("response-->", response);
    } catch (err) {
    //  console.log(err);
    }
  };

  return (
    <div
      className={
        localStorage.getItem("gs3_AuthToken")
          ? "container-fluid"
          : "container-fluid contactUsMain"
      }
    >
      <div className="dbMain">
        <Leftpanel />
        <div className="dbRight">
          <Header link="#" breadcm="" title="Contact Us" description="" />
          <div className="commonBase">
            <div className="contactBase">
              {localStorage.getItem("gs3_AuthToken") ? (
                ""
              ) : (
                <h2 className="text-center pb-4">Contact Us</h2>
              )}
              <div className="row">
                <div className="col-md-12 mb-3">
                  <select
                    className="form-control"
                    name="queryType"
                    onChange={(e) =>
                      setContactUsData({
                        ...contactUsData,
                        queryType: e.target.value,
                      })
                    }
                  >
                    <option value={""}>Select Query Type</option>
                    <option value={"General"}>General</option>
                    <option value={"Configuration"}>Configuration</option>
                    <option value={"Orders"}>Orders</option>
                    <option value={"Raise a Complained"}>
                      Raise a Complained
                    </option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    id=""
                    className="form-control"
                    placeholder="First name"
                    name="firstName"
                    onChange={(e) =>
                      setContactUsData({
                        ...contactUsData,
                        firstName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    id=""
                    className="form-control"
                    placeholder="Last name"
                    name="lastName"
                    onChange={(e) =>
                      setContactUsData({
                        ...contactUsData,
                        lastName: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    id=""
                    className="form-control"
                    placeholder="Email address"
                    name="email"
                    onChange={(e) =>
                      setContactUsData({
                        ...contactUsData,
                        email: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    id=""
                    className="form-control"
                    placeholder="Contact number"
                    name="phone"
                    onChange={(e) =>
                      setContactUsData({
                        ...contactUsData,
                        phone: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <textarea
                    className="form-control"
                    name="message"
                    placeholder="Comment"
                    onChange={(e) =>
                      setContactUsData({
                        ...contactUsData,
                        message: e.target.value,
                      })
                    }
                  ></textarea>
                </div>
              </div>
              <div>
                <button
                  type="submit"
                  className="commonButton"
                  onClick={_ON_SUBMIT}
                >
                  Contact us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactus;
